<div class="container-fluid workload">
  <form [formGroup]="workTaskForm">
    <h2 class="step-title">Trabajo a realizar</h2>
    <hr class="solid" />
    <div>
      <h3 class="section-title">Tipo de tarea *</h3>
      <div class="row d-flex">
        <ul class="taskJob list-inline mx-auto justify-content-center">
          @for (group of taskGroups; track group) {
            <li [value]="group.id" class="list-inline-item">
            <label (click)="getJobs(group)" [ngClass]="{
                taskGroupActive:
                  selectedTaskGroup && group.id == selectedTaskGroup.id
              }">
                <span>{{ group.description }}</span>
              </label>
            </li>
          }
        </ul>
        <br />
      </div>
      @if (jobs.length) {
        <div>
          <h3 class="section-title" [class.section-title--invalid]="jobMissing">Subcategoría *</h3>
          <div class="row d-flex">
            <ul class="taskJob list-inline mx-auto justify-content-center mt-0">
              @for (job of jobs; track job) {
                <li class="list-inline-item">
              <label (click)="selectJob(job)" [ngClass]="{
                  jobActive: selectedJob && job.id == selectedJob.id
                }">
                    <span>{{ job.description }}</span>
                  </label>
                </li>
              }
            </ul>
            <br />
          </div>
        </div>
      }
      @if (jobMissing && selectedTaskGroup) {
        <p class="field-error" role="alert">
          {{ jobs.length ? 'Elegí una subcategoría.' : 'Este tipo de tarea no tiene subcategorías disponibles.' }}
        </p>
      }
      @if (hasWorkTaskRules) {
        <div class="d-flex pb-2">
          <mat-slide-toggle formControlName="applyRules">
            <b>Crear tareas relacionadas</b>
          </mat-slide-toggle>
        </div>
      }
      @if (showVisits && visitsList.length > 0) {
        <div class="mb-3">
          <mat-form-field class="col-11" appearance="outline">
            <mat-label>Visitas realizadas</mat-label>
            <mat-select id="quality" formControlName="visit">
              @for (visit of visitsList; track visit) {
                <mat-option [value]="visit">
                  {{ visit.creationDate | date }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-icon class="col-1" (click)="clearVisit()">delete_outline</mat-icon>
        </div>
      }
      @if (selectedJob) {
        <div class="row mb-3">
          <h3 class="section-title mt-2">Producto</h3>
          @if (products.length > 0) {
            <mat-form-field appearance="outline">
              <mat-label>Productos</mat-label>
              <mat-select id="product" formControlName="product">
                @for (p of products; track p) {
                  <mat-option [value]="p.id" (selectionChange)="getSuppliers()">
                    {{ p.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          <ng-container>
            @if (products.length == 0) {
              <span class="no-prods">No existen productos para la combinación seleccionada de
                Tipo de
              tarea y Subcategoría.</span>
            }</ng-container>
          </div>
        }
        @if (showProductProps) {
          <div class="row mb-3">
            <mat-form-field appearance="outline">
              <mat-label>Colores</mat-label>
              <mat-select id="colors" formControlName="productColor">
                @for (color of colorList; track color) {
                  <mat-option [value]="color.id">
                    {{ color.color }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
        @if (showProductProps) {
          <div class="row mb-3">
            <mat-form-field appearance="outline">
              <mat-label>Calidad</mat-label>
              <mat-select id="quality" formControlName="productQuality">
                @for (quality of productsQualityList; track quality) {
                  <mat-option [value]="quality.id">
                    {{ quality.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
        @if (showRevetmentProps || showRevetmentPropsByDefault) {
          <div class="row">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Excedente</mat-label>
              <input matInput placeholder="mts2" class="revEx" type="number" min="0" step="0.01"
                formControlName="revetmentSurplus"
                onkeydown="return event.key !== 'e' && event.key !== '+' && event.key !== 'E';" />
              </mat-form-field>
            </div>
          }
          <div class="row mb-5">
        <div [class.col-12]="true" [class.col-lg-7]="
            userSvc.hasPermission('add:schedule') ||
            (userSvc.hasPermission('add:scheduleTerrain') &&
              selectedJobId == TERRAIN_VISIT_ID)
          ">
              <h3 class="section-title">Comentarios *</h3>
              <mat-form-field class="w-100 h-50" appearance="outline">
                <mat-label>Comentarios</mat-label>
                <textarea matInput matTextareaAutosize="5" type="text" placeholder="Haz tu comentario." name="description"
                  formControlName="description" [rows]="4" required>
                </textarea>
              </mat-form-field>
            </div>
            @if (
              userSvc.hasPermission('add:schedule') ||
              (userSvc.hasPermission('add:scheduleTerrain') &&
              selectedJobId == TERRAIN_VISIT_ID)
              ) {
              <div class="col-12 col-lg-5">
                <h3 class="section-title">Fecha de realización</h3>
                <div class="d-flex flex-wrap align-items-start date-time-row">
                  <mat-form-field class="date-field" appearance="outline">
                    <mat-label>Fecha de realización</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="date" [min]="minDate" />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <div class="row timePickerRow">
                    <div class="col-lg-3 ngx-timepicker-field">
                      <ngx-timepicker-field formControlName="time" [toggleIcon]="icon" [format]="24" [clockTheme]="clockTheme" [min]="minHour"
                        [defaultTime]="minHour" (timeChanged)="onTimeChanged($event)"
                        [disabled]="!workTaskForm.controls.date.value">
                      </ngx-timepicker-field>
                      <ng-template #icon>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="30px" height="30px"
                          (click)="setTime()">
                          <path
                            d="M15,3C8.373,3,3,8.373,3,15c0,6.627,5.373,12,12,12s12-5.373,12-12C27,8.373,21.627,3,15,3z M16,16H7.995 C7.445,16,7,15.555,7,15.005v-0.011C7,14.445,7.445,14,7.995,14H14V5.995C14,5.445,14.445,5,14.995,5h0.011 C15.555,5,16,5.445,16,5.995V16z" />
                          </svg>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>

            <hr class="solid" />
            <div class="row d-flex justify-content-start pt-2 pb-2">
              <div class="col-2 d-flex justify-content-start align-items-center">
                <mat-slide-toggle formControlName="isPromotional" [(ngModel)]="showProimotionaldiscount">
                  <b>Tarea promocional</b>
                </mat-slide-toggle>
              </div>
              @if (showProimotionaldiscount) {
                <div class="col-2 d-flex justify-content-start align-items-center">
                  <mat-form-field class="w-50 discount" appearance="outline">
                    <mat-label>% descuento</mat-label>
                    <input matInput formControlName="discountApplied" [(ngModel)]="promDiscount" type="number" max="99" min="0"
                    (keyup)="validateOnlyPositiveNumbers($event)" /></mat-form-field>
                  </div>
                }
              </div>
              <hr class="solid" />

              @if (
                userSvc.hasPermission('add:assignContractor') ||
                (userSvc.hasPermission('add:assignContractorTerrain') &&
                selectedJobId == TERRAIN_VISIT_ID)
                ) {
                <div class="row">
                  <div class="row w-100 m-0 heading">
                    <div class="col-md-6 col-12 mt-3">
                      <h3 class="section-title">Asignar prestador</h3>
                    </div>
                    <div class="col-md-6 col-12" style="z-index: 1">
                      <div class="input-group">
                        <input type="text" class="form-control" placeholder="  Buscar" [(ngModel)]="searchText"
                          [ngModelOptions]="{ standalone: true }" />
                          <span>
                            <mat-icon>search</mat-icon>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row ms-3">
                    @if (workTaskForm.controls.date.value && !timeSelected) {
                      <p class="supplier-hint" role="status">Sin hora no se filtra por disponibilidad: se muestran todos los prestadores. La hora y el prestador son opcionales.</p>
                    } @else if (workTaskForm.controls.date.value && supplierList.length === 0) {
                      <p class="supplier-hint" role="status">No hay prestadores disponibles para esa fecha y hora. Podés guardar la OT sin prestador.</p>
                    }
                    <mat-selection-list [multiple]="false" [hideSingleSelectionIndicator]="true">
                      @for (item of supplierList | filterByName : searchText; track item) {
                        <mat-list-option [value]="item.id" (click)="selectContractor($event, item)"
                          [ngClass]="{ 'selected': selectedContractor == item.id }" [tabIndex]="-1">
                          <div class="row w-100 h-40 supplierItem">
                            <div class="col-3">
                    <div class="avatar" [style.background]="
                        'url(' + imageSvc.getImage(item.url) + ')'
                      ">
                      <div class="status-circle" [style.background-color]="
                          imageSvc.getColorByStatus(item.stateId)
                        "></div>
                              </div>
                            </div>
                            <div class="col-9 description">
                              <span>{{ item.fullName }}</span>
                            </div>
                          </div>
                        </mat-list-option>
                      }
                    </mat-selection-list>
                  </div>
                  <hr class="solid" />
                }

                <div class="row">
                  <div class="col-lg-12">
                    <button mat-mdc-raised-button class="ind-button bg-ind-green float-right" type="button"
                      (click)="addWorkTask()">
                      Agregar
                    </button>
                  </div>
                </div>

                <div class="row taskDetailContent mt-3 pt-3 pb-3">
                  <h3 class="subtitle">Tareas</h3>
                  @for (workTask of jobsList; track workTask; let indexOfelement = $index) {
                    <div class="mb-2 col-lg-4">
                      <mat-card appearance="outlined">
                        <mat-card-title>
                          <div class="row">
                            <div class="col-10 float-left">
                              <h3 class="float-left">
                                {{ workTask.taskGroupDescription + " - " + workTask.taskDescription }}
                              </h3>
                            </div>
                            <div class="col-2 float-right">
                              <mat-icon (click)="removeWorkTask(indexOfelement); disableButton()">delete_forever</mat-icon>
                            </div>
                          </div>
                        </mat-card-title>
                        <mat-card-content class="pb-2">
                          <div class="row">
                            <div class="col-12">
                              <span> <b>Cliente: </b> {{ client?.name }}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <span> <b>DNI: </b> {{ client?.identificationNumber }} </span>
                            </div>
                          </div>
                          <hr class="solid" />
                          <div class="row">
                            <div class="col-1">
                              <mat-icon>calendar_today</mat-icon>
                            </div>
                            <div class="col-11">
                              <label><b>Fecha: </b>@if (workTask.date) {
                              <span>{{ workTask.date | date : "dd/MM/yyyy" }}
                              {{ workTask.isTimeSelected ? " - " + (workTask.date | date : "HH:mm") : "" }}</span>
                            }</label>
                          </div>
                        </div>
                        <hr class="solid" />
                        <div class="row">
                          <div class="col-1">
                            <mat-icon>person</mat-icon>
                          </div>
                          <div class="col-11">
                            <label><b>Prestador: </b>{{ workTask.contractorName }}</label>
                          </div>
                        </div>
                        <hr class="solid" />
                        <div class="row">
                          <div class="col-1">
                            <mat-icon>shopping_basket</mat-icon>
                          </div>
                          <div class="col-11">
                            <label>
                              <b>Producto: </b>
                            {{ workTask.productName }}</label>
                          </div>
                        </div>
                      </mat-card-content>
                    </mat-card>
                  </div>
                }
              </div>
            </div>
          </form>
        </div>